import { render, staticRenderFns } from "./AddCustomization.vue?vue&type=template&id=bcfde9d0&scoped=true&"
import script from "./AddCustomization.vue?vue&type=script&lang=js&"
export * from "./AddCustomization.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomization.vue?vue&type=style&index=0&id=bcfde9d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfde9d0",
  null
  
)

export default component.exports